module.exports = __webpack_public_path__ + "media/high_school_students/orange_arrow-8d6d2d40.png";